import { BaseApi, cancelInit, CancelTokenKeyCommit } from '@/main/baseApi';
import { Administrace } from '@/modules/administrace';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { NAME } from './constants';

class ZpravyProvider extends BaseApi {
	async getZpravyCount() {
		return this.fetch(`/${Administrace.name}/${NAME}/GetZpravyCount`);
	}

	async getZpravaUserMessage(dmsUserMessageId: number) {
		return this.fetch(`/${Administrace.name}/${NAME}/GetZpravaUserMessage?dmsUserMessageId=${dmsUserMessageId}`);
	}

	async getSystemoveUpozorneni(dmsUserMessageId: number) {
		return this.fetch(`/${Administrace.name}/${NAME}/GetSystemoveUpozorneni?dmsUserMessageId=${dmsUserMessageId}`);
	}

	async vyriditAktivovatZpravu(zaznamId: number, vyridit = true) {
		return this.update(`/${Administrace.name}/${NAME}/VyriditAktivovatZpravu?zaznamId=${zaznamId}&vyridit=${vyridit}`);
	}

	async doPoznamek(dmsUserMessageId: number) {
		return this.post(`/${Administrace.name}/${NAME}/DoPoznamek?dmsUserMessageId=${dmsUserMessageId}`);
	}

	tableSchema({ cancelTokenKey, commit, filter }: any = cancelInit) { // CancelTokenKeyCommit
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`${this.tableSchemaUrl()}Schema`, { zpravyDruhEnum: filter.zpravyDruhEnum }, { cancelPtr });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}

	tableData(filter?: object, { cancelTokenKey, commit }: CancelTokenKeyCommit = cancelInit) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const rowsRequestSuffix = '';
		const resp = this.fetch(`${this.tableDataUrl()}${rowsRequestSuffix}`, filter, { cancelPtr });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}
}

export const apiProvider = new ZpravyProvider(Administrace.name, NAME);
